import { upsellPageDataDbWriteValidator } from "@redotech/redo-model/upsell-page/upsell-page-db-validator";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createUpsellPage = {
  name: "createUpsellPage" as const,
  input: z.object({
    /**
     * Don't use this when not necessary (only used in old upsell page/flow builder).
     * It's an odd pattern to have the client generate the ID, but it's kept for
     * backwards compatibility with the old implementation of 1CU.
     */
    upsellPageId: zExt.objectId().optional(),
    teamId: zExt.objectId(),
    upsellPageData: upsellPageDataDbWriteValidator,
  }),
  output: z.object({ upsellPageId: zExt.objectId() }),
};
